import {ContactModel} from '../models/checkout/Cart/Contact.model';

export function isContactDefined(contact?: ContactModel) {
  return Object.values(contact ?? /* istanbul ignore next */ {}).filter((value) => !!value).length > 0;
}
